import React from 'react';
import CMSPage from '../../components/CMSPage/CMSPage';

const FAQPage = () => {
  return <CMSPage pageType="faq" />;
};

export default FAQPage;
